import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Pagination } from 'react-bootstrap';


import { Shapes } from '../../models/entities';

class PaginationBar extends PureComponent {
  renderFirst() {
    const { pagination, onChangePage } = this.props;
    if (pagination.pageNumber > 0) {
      return (<Pagination.First onClick={() => onChangePage(0)} />);
    }
    return null;
  }

  renderPrevious() {
    const { pagination, onChangePage } = this.props;
    if (pagination.pageNumber > 0) {
      return (<Pagination.Prev onClick={() => onChangePage(pagination.pageNumber - 1)} />);
    }
    return null;
  }

  renderNext() {
    const { pagination, onChangePage } = this.props;
    if (pagination.pageNumber < pagination.totalPages - 1) {
      return (<Pagination.Next onClick={() => onChangePage(pagination.pageNumber + 1)} />);
    }
    return null;
  }

  renderLast() {
    const { pagination, onChangePage } = this.props;
    if (pagination.pageNumber < pagination.totalPages - 1) {
      return (<Pagination.Last onClick={() => onChangePage(pagination.totalPages - 1)} />);
    }
    return null;
  }

  render() {
    const { pagination } = this.props;
    return (
      <Pagination style={{ justifyContent: 'center' }}>
        {this.renderFirst()}
        {this.renderPrevious()}
        <Pagination.Item>
          {pagination.pageNumber + 1}
          &nbsp;of&nbsp;
          {pagination.totalPages}
        </Pagination.Item>
        {this.renderNext()}
        {this.renderLast()}
      </Pagination>
    );
  }
}

PaginationBar.propTypes = {
  pagination: Shapes.PAGINATION.isRequired,
  onChangePage: PropTypes.func.isRequired,
};

export default PaginationBar;
